module.exports = __webpack_public_path__ + "img/poster-2.17fb9f7a.jpg";